export const base64Decode = (base64) => {
  const decodedPayload = JSON.parse(window.atob(base64));
  return decodedPayload;
};
